module.exports = __webpack_public_path__ + "f29f0743dd87d81bd25a5eebc334d883.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homebg.jpg
// module id = 171
// module chunks = 0